'use client';
import React, { memo, useRef } from 'react';
import Slider, { Settings } from 'react-slick';
import Image from 'next/image';

import { useGetProudsQuery } from '@/store/api/proud.api';
import { CaseStudy } from '@/types/case-study';
import { getImageUrl, map } from '@/utils';

import { NextArrow, PrevArrow, SlideController } from './config';
import SlideCard from './SlideCard';

import '@/styles/motto-slick.css';

interface IProps {}

const MottoSlider = () => {
	const { data: proudsData } = useGetProudsQuery({
		page: 1,
		pageSize: 4,
	});

	let sliderRef: any = useRef(null);
	const onNext = () => {
		if (!sliderRef.current) return;
		sliderRef.current.slickNext();
	};
	const onPrev = () => {
		if (!sliderRef.current) return;
		sliderRef.current.slickPrev();
	};

	const settings: Settings = {
		customPaging: function (index: number) {
			const currentSlide = proudsData?.data[index];
			return (
				<div className="center relative h-full w-full overflow-hidden rounded-3xl p-2 max-lg:!hidden">
					<div className="relative aspect-[287/215] w-full overflow-hidden rounded-2xl bg-white">
						<Image
							src={getImageUrl(currentSlide?.image).imageUrl}
							blurDataURL={
								getImageUrl(currentSlide?.image)
									.imagePlaceholder
							}
							alt={currentSlide?.title || 'DLA Da Nang'}
							placeholder="blur"
							fill
							priority
							className="object-cover object-center"
						/>
					</div>
				</div>
			);
		},
		dots: true,
		dotsClass:
			'slick-dots dot-active slick-thumb !bottom-auto !relative !mt-6 *:min-w-[272px] *:min-h-[200px]',
		nextArrow: <NextArrow />,
		prevArrow: <PrevArrow />,
		infinite: true,
		speed: 500,
		slidesToShow: 1,
		slidesToScroll: 1,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					dots: false,
				},
			},
		],
		beforeChange: (current: number, next: number) => {},
		afterChange: (current: number) => {},
	};

	return (
		<div className="mx-auto max-w-[1182px]" data-aos="zoom-in">
			<Slider
				ref={(slider) => {
					sliderRef.current = slider;
				}}
				{...settings}
			>
				{map(proudsData?.data || [], (item: CaseStudy, idx: number) => (
					<SlideCard key={item.id || idx} data={item} />
				))}
			</Slider>

			<SlideController onNext={onNext} onPrev={onPrev} />
		</div>
	);
};

export default memo(MottoSlider);
